// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__17XUG","bio":"styles_bio__13kqN"};